import { PUSH, CLEAR } from '../actions/errors';

const initialState = {
  errors: [],
};

const errorReducer = (state = initialState, { type, ...error }) => {
  switch (type) {
    case PUSH:
      return {
        errors: [...state.errors, { ...error, timestamp: Date.now() }],
      };
    case CLEAR:
      return {
        errors: [],
      };
    default:
      return state;
  }
};

export default errorReducer;
